// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturesTypeFirst_feature__14U_M","title":"FeaturesTypeFirst_title__71zG8"};